<template>
	<div class="homePage">
		<HomeBanner :banners='banners' :isShowDot='true'/>
		<SearchBar :cruiseFilters='cruiseFilters'
		:isShowHp="true"/>
<!--		<login-part class="homePage-login" v-if="!isLogin"/>-->
		<HomeRecommendCruise v-if="cruiseCategories.length > 0 && promoCruiseItems.length > 0"
			:cruiseCategories='cruiseCategories'
			:promoCruiseItems='promoCruiseItems'/>
		<HomeTopic :promoBanners='promoBanners'/>
		<RoyalShip :homeShip='homeShip'/>
		<HomeDestination :destinations='destinations' />
<!--    <a class="global-airline" href="https://www.royalcaribbean.com/ultimate-world-cruise/">-->
<!--      <img src="https://resource.rcclchina.com.cn/00susie/Banner/globalAirline-pc-20230511.jpg" />-->
<!--    </a>-->
    <div class="global-airline">
      <img src="https://resource.rcclchina.com.cn/Home/turntable/globalAirline-PC-20260421.jpg" />
    </div>
		<HomeReview :reviewArticles='reviewArticles' />

		<EmergencyMessageAlert />

		<!-- <div class="wn-baby-left wn-baby-image" v-if="showPromo===0" id="wnBabyLeft"
		:class="{ hover: isShowPromoEffect}" @mouseover="showEffect" @mouseleave="closeEffect" @click="goPromo">
      <img src="https://resource.rcclchina.com.cn/homePage/promotion/2.gif"/>
    </div>
    <div class="wn-baby-right wn-baby-image" v-else-if="showPromo===1" id="wnBabyRight"
		:class="{ hover: isShowPromoEffect}" @mouseover="showEffect" @mouseleave="closeEffect" @click="goPromo">
      <img src="https://resource.rcclchina.com.cn/homePage/promotion/1.gif"/>
    </div> -->
	</div>
</template>

<script>
import Cookies from 'js-cookie';
import { getRandomInt } from '@/utilities/tools'

const promoCountDown = 8 * 1000;
const randomPromoOff = 1 * 1000;
const randomPromoShow = 6 * 1000 + randomPromoOff;

const HomeBanner = () => import('@/components/Home/HomeBanner')
// const LoginPart = ()=> import('@/components/User/LoginPart')
const SearchBar = () => import('@/components/SearchBar/SearchBar')
const HomeRecommendCruise = () => import('@/components/Home/HomeRecommendCruise')
const HomeTopic = ()=> import('@/components/Home/HomeTopic')
const RoyalShip = ()=> import('@/components/Home/RoyalShip')
const HomeDestination = ()=> import('@/components/Home/HomeDestination')
const HomeReview = ()=> import('@/components/Home/HomeReview')
const EmergencyMessageAlert = ()=> import('@/components/Common/EmergencyMessageAlert')

export default {
	name: 'index',
	components: {
		HomeBanner,
		// LoginPart,
		SearchBar,
		HomeRecommendCruise,
		HomeTopic,
		RoyalShip,
		HomeDestination,
		HomeReview,
		EmergencyMessageAlert,
	},
	asyncData ({ store }) {
		return new Promise((resolve, reject) => {
			const userName = store.state.user.userToken
			const cruiseId = Cookies.get("CruiseIds")
			return store.dispatch('GET_HOME_PAGE', { userName, cruiseId})
			.then(()=> {
				return store.dispatch('GET_CRUISE_FILTERS')
			})
			.then(()=> {
				resolve();
			})
			.catch((e)=> {
				reject(e)
			})
		})
	},
	data () {
		return {
			isLogin: true,
			checkPromoTimeout: null,
			promoEffectInterval: null,
			showPromo: -1,
			isShowPromoEffect: false,
			isPromoHover: false
		}
	},
	beforeMount () {
		const seo = {
			title: "海洋光谱号-皇家加勒比国际游轮官方网站",
			description: "皇家加勒比国际游轮有限公司是全球著名游轮旅游服务公司,全球性豪华游轮品牌. 旗下豪华皇家船队包含: 海洋光谱号、海洋量子号、海洋航行者号等豪华游轮",
			keyword: "皇家加勒比,皇家加勒比国际游轮官网,皇家加勒比国际游轮,豪华游轮旅游,豪华游轮,海洋光谱号, 奇迹号游轮 皇家奇迹号 光谱号游轮 皇家光谱号 奇迹号邮轮 光谱号邮轮"
		}
		this.$store.commit("SET_META", seo);

		const userToken = this.$store.state.user.userToken
		this.isLogin = userToken && userToken.length > 0
		// this.showPromoTimeout();
	},
	beforeDestroy () {
		this.showPromo = -1;
		if (this.checkPromoTimeout) {
			clearTimeout(this.checkPromoTimeout);
		}
		if (this.promoEffectInterval) {
			clearInterval(this.promoEffectInterval)
		}
	},
	methods: {
		showPromoTimeout () {
			if (this.checkPromoTimeout) {
				clearTimeout(this.checkPromoTimeout);
			}
			this.checkPromoTimeout = setTimeout(()=> {
				if (!this.userInfo || this.userInfo.userIdentity !== 1) {
					this.showPromoPopup();
				}
			}, promoCountDown)
		},
		showPromoPopup () {
			let random = Math.round(Math.random(100));
			this.showPromo = random % 2;
			if (this.showPromo === 0) {
				// 左边，位置出现在 10% ~ 80%
				let top = getRandomInt(10, 80);
				this.$nextTick(()=> {
					document.getElementById('wnBabyLeft').style.top = top + '%';
					this.showPromoEffect()
				})
			} else if (this.showPromo === 1) {
				// 右边 7% 或者 70%
				let top = 7;
				let now = new Date().getTime();
				if (now % 2 === 0) {
					top = 70;
				}
				this.$nextTick(()=> {
					document.getElementById('wnBabyRight').style.top = top + '%';
					this.showPromoEffect();
				})
			}
		},
		showPromoEffect () {
      if (this.promoEffectInterval) {
        clearInterval(this.promoEffectInterval)
      }
      this.promoEffectInterval = setInterval(()=> {
        this.isShowPromoEffect = true;
				setTimeout(()=> {
					if (!this.isPromoHover) {
						this.isShowPromoEffect = false;
					}
				}, randomPromoOff)
      }, randomPromoShow);
    },
		showEffect () {
			this.isPromoHover = true;
			this.isShowPromoEffect = true;
			if (this.checkPromoTimeout) {
				clearTimeout(this.checkPromoTimeout);
			}
			if (this.promoEffectInterval) {
				clearInterval(this.promoEffectInterval)
			}
		},
		closeEffect () {
			this.isPromoHover = false;
			this.isShowPromoEffect = false;
			this.showPromoEffect();
		},
		goPromo() {
      window.open("https://www.rcclchina.com.cn/privilege/qibao")
    }

	},
	computed: {
		banners () {
			const homePage = this.$store.state.page.homePage
			if (homePage && homePage.homeBanners)  {
				return homePage.homeBanners.filter(function(banner) {
					return banner.type == 1
				})
			}
			return []
		},
		cruiseFilters () {
			return this.$store.state.cruise.cruiseFilters
		},
		cruiseCategories () {
			const homePage = this.$store.state.page.homePage
			if (homePage
			&& homePage.recommendCruiseArea
			&& homePage.recommendCruiseArea.promoCruiseCategories) {
				return homePage.recommendCruiseArea.promoCruiseCategories
			}
			return []
		},
		promoCruiseItems () {
			const homePage = this.$store.state.page.homePage
			if (homePage
			&& homePage.recommendCruiseArea
			&& homePage.recommendCruiseArea.cruisePromoItems) {
				return homePage.recommendCruiseArea.cruisePromoItems
			}
			return []
		},
		promoBanners () {
			const homePage = this.$store.state.page.homePage
			if (homePage
			&& homePage.recommendCruiseArea
			&& homePage.recommendCruiseArea.promoBanners) {
				return homePage.recommendCruiseArea.promoBanners
			}
			return []
		},
		homeShip () {
			return this.$store.state.page.homePage.royalShip
		},
		destinations () {
      console.log(this.$store.state.page.homePage.recommendDestinations)
			return this.$store.state.page.homePage.recommendDestinations
		},
		reviewArticles () {
			const homePage = this.$store.state.page.homePage
			if (homePage
			&& homePage.recommendCruiseArea
			&& homePage.recommendCruiseArea.reviewArticles) {
				return this.$store.state.page.homePage.recommendCruiseArea.reviewArticles
			}
			return []
		},
		userInfo () {
			return this.$store.state.user.userInfo
		}
	}
}
</script>

<style lang="less" scoped>
.wn-baby-image {
	position: fixed;
	width: 150px;

	z-index: 1112;
	cursor: pointer;
	img {
		width: 100%;
	}
}
.wn-baby-left {
	left: -64px;
	top: 50%;
	transition: left 0.2s;
	&.hover {
		left: -30px;
	}
}

.wn-baby-right {
	right: -64px;
	top: 10%;
	transition: right 0.2s;
	&.hover {
		right: -35px;
	}
}


</style>

<style>
@charset "UTF-8";
h2,h3{
	margin:0;
	padding:0;
}
a:hover{
	text-decoration: none;
}
.homePage {
	position: relative;
	top: -72px;
}
.link-btn{
	display: block;
	width: 304px;
	height: 38px;
	text-align: center;
	line-height: 38px;
	color: #006bad;
	font-size: 14px;
	margin: 0 auto;
	border: 1px solid #006bad;
	cursor: pointer;
	font-weight: 500;
}
.link-btn:hover{
	background: #E5F3FF;
}
.carousel.slide{
	height: 100%;
	overflow: hidden;
}


/*搜索框*/
.homepage-searchbar {
	/* margin-top: -35px; */
	margin-bottom: 36px;
	position: relative;
	z-index: 20;
}

.homePage .homePage-login {
	margin-top: 40px !important;
	margin-bottom: 40px !important;
}

/*限时抢购*/
.homepage-recommand-cruises .title{
	font-size: 30px;
	font-weight: bold;
	line-height: 78px;
	text-align: center;
	color: #282b2c;
}
.homepage-recommand-cruises .cruise-nav{
	display: flex;
	justify-content: center;
	width: 1200px;
	height: 50px;
	background: #f8f8f8;
	margin: 0 auto 26px;
	font-weight: 600;
	font-size: 16px;
}

.homepage-recommand-cruises .cruise-nav li{
	height: 100%;
  flex: 1;
	text-align: center;
	line-height: 50px;
	background: url('https://resource.rcclchina.com.cn/homePage/homePage-libg.png') no-repeat right center;
	cursor:pointer;
	position: relative;
}
.homepage-recommand-cruises .cruise-nav li::before,
.homepage-recommand-cruises .cruise-nav li::after{
	content: "";
	position: absolute;
	bottom: 0;
	left: 50%;
	height: 4px;
	width: 0;
	background-color: #0073bb;
	transition: all .25s linear;
}
.homepage-recommand-cruises .cruise-nav.active-sec li{
	width: 240px;
}
.homepage-recommand-cruises .cruise-nav.active-thr li{
	width: 400px;
}
.homepage-recommand-cruises .cruise-nav li:last-child{
	background: none;
}
.homepage-recommand-cruises  .cruise-nav li:hover{
	color:#006bad;
}
/* .homepage-recommand-cruises  .cruise-nav li.active{

} */
.homepage-recommand-cruises  .cruise-nav li.active::before{
	width: 50%;
	left:0;
}
.homepage-recommand-cruises  .cruise-nav li.active::after{
	width: 50%;
}
.homepage-recommand-cruises .cruise-content{
	width: 1200px;
	margin: 0 auto;
	display: none;
	justify-content:flex-start;
	flex-wrap: wrap;
}
.homepage-recommand-cruises .cruise-content.active{
	display: flex;
}

.homepage-recommand-cruises .cruise-content li{
	width: 400px;
	position: relative;
	/* cursor: pointer; */
	padding: 14px;
	box-sizing: border-box;
	transform-style: preserve-3d;
	perspective: 800px;
	transition: all .5s;
	cursor: pointer;
}

/*
.homepage-recommand-cruises .cruise-content li img{
	transition: transform 1s;
}*/
.homepage-recommand-cruises .cruise-content li:hover{
	transform: translate3d(0px,0px,8px);
	box-shadow: 0px 0px 12px 7px rgba(46, 65, 80, 0.1);
}
/*
.homepage-recommand-cruises .cruise-content li:hover img
{
	transform: translate3d(2px,0,0);
}*/
/*.homepage-recommand-cruises .cruise-content li:hover{
	padding: 10px;
}*/
.homepage-recommand-cruises .cruise-content li .img-tag{
	position: absolute;
	left: 10px;
	top: 36px;
	width: 108px;
	height: 37px;
	background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/bg-tag-1.jpg) no-repeat 100%;
	z-index: 2;
}
.homepage-recommand-cruises .cruise-content li .img-tag .tag-text{
	height: 28px;
	line-height: 28px;
	color: #fff;
	text-align: center;
}
.homepage-recommand-cruises .cruise-content li .heart{
	position: absolute;
	top: 26px;
	right: 28px;
	z-index: 2;
	cursor: pointer;
}
.homepage-recommand-cruises .cruise-content li .cruise-img{
	width: 372px;
	height: 372px;
	overflow: hidden;
	position: relative;
	z-index: -1;
}
.homepage-recommand-cruises .cruise-content li .cruise-img img{

	position: absolute;
	left:0;
	top:0;
}

.homepage-recommand-cruises .cruise-content li .cruise-img .cruise-img-line {
	position: absolute;
	height: 2px;
	width: 100%;
	background-color: #1178ab;
	bottom: 0;
}

.homepage-recommand-cruises .cruise-content li .cruise-img img.cru-img1{
	z-index: -2;
}
.homepage-recommand-cruises .cruise-content li .cruise-img img.cru-img2{
	top: 100%;
	transition: top 0.5s;
	z-index: 1;
}
.homepage-recommand-cruises .cruise-content li .cruise-image-content:hover img.cru-img2{
	top: 0;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro{
	font-size: 14px;
	color: #282b2c;
	position: relative;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .cruise-title{
	padding: 10px 14px 0 14px;
	font-size: 14px;
	color: #282b2c;
	font-weight: 500;
	height: 89px;
}
.homepage-recommand-cruises .cruise-content li .cruise-img .ship{
	width:144px;
	height: 28px;
	background: rgba(0, 115, 187, 0.9);
	position: absolute;
	left: 50%;
	margin-left: -72px;
	bottom: 0px;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	color: #fff;
	text-align:center;
	line-height: 28px;
	font-size: 14px;
	cursor: pointer;
	display: block;
}

.homepage-recommand-cruises .cruise-content li .cruise-img .ship img {
	position: relative;
	top: initial;
	left: initial;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .text{
	font-size: 16px;
	color: #282b2c;
	font-weight: bold;
	height: 44px;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

/*.homepage-recommand-cruises .cruise-content li .cruise-intro .text::after {
	content:"...";
	position:absolute;
	bottom:0;
	right:0;
}*/

.homepage-recommand-cruises .cruise-content li .cruise-intro .text .tour{
	position: absolute;
	right: 0px;
	top: 42px;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .time{
	font-size: 14px;
	color: #282b2c;

}

.homepage-recommand-cruises .cruise-content li .cruise-intro .price {
	padding: 0px 14px 0 14px;
	font-size: 14px;
	color: #282b2c;
	font-weight: 500;
	margin-bottom: 0px;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .price span{
	font-size: 24px;
	font-weight: bold;
	color: #ffa70d;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .price span i{
	font-size: 16px;
	font-weight: bold;
	font-style: normal;
	color: #ffa70d;
}
.homepage-recommand-cruises  .cruise-content li .cruise-intro .dataTime{
	line-height: 50px;
	position:relative;
	background: #f8f8f8;
	font-weight: 500;
	overflow: hidden;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime>img{
	position: absolute;
	top: 15px;
	left: 15px;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime span{
	color: #ffa70d;
	font-size: 24px;
	font-weight: 400;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime i{
	font-style: normal;
	position: relative;
	top: -2px;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime .link.order{
	height: 50px;
	width: 100%;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime .link.order.hasCountDown {
	height: 50px;
	width: 50%;
	float:right;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime span.num:first-child{
	margin-left: 40px;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime a.link{
	display: inline-block;
	width: 188px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	background: #fbc500;
	font-size: 20px;
	color: #282b2c;
	float: left;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime a.link:hover{
	text-decoration: none;
	background: #f8de57;
}


/*精选专题*/
.homepage-topics .main-topics{
	width: 1200px;
	margin: 55px auto 0;

}
.homepage-topics .main-topics .main-title{
	margin-bottom: 30px;
}
.homepage-topics .main-topics .main-title .title{
	font-size: 30px;
	font-weight: bold;
	text-align: center;
	color: #282b2c;
}
.homepage-topics .main-topics .main-title .subtitle{
	font-size: 14px;
	text-align: center;
	color: #282b2c;
	font-weight: 500;
	line-height: 34px;
}
.homepage-topics .main-topics .list-topics{
	width: 100%;
	height: 304px;
	display: flex;
	justify-content: space-between;
}
.homepage-topics .main-topics .list-topics li{
	width: 394px;
	height: 100%;
	overflow:hidden;
	cursor:pointer;
	position:relative;
}
.homepage-topics .main-topics .list-topics li img{
	transition: all 0.5s;
}
.homepage-topics .main-topics .list-topics li:hover img{
	transform: scale(1.1,1.1);
}
.homepage-topics .main-topics .list-topics li a{
	display: block;
}
.homepage-topics .main-topics .list-topics li a img{
	width: 100%;
}

/*皇家游轮体验*/
.homepage-ships{
	padding-top: 55px;
}
.homepage-ships .main-experience{
	width: 1200px;
	margin: 66px auto 0;
}
.homepage-ships .main-title{
	margin-bottom:30px;
	text-align: center;
}
.homepage-ships .main-title .title {
	font-size: 30px;
	font-weight: bold;
	text-align: center;
	color: #282b2c;
}
.homepage-ships .main-title .subtitle {
	font-size: 14px;
	text-align: center;
	color: #282b2c;
	font-weight: 500;
	line-height: 34px;
}
.homepage-ships .main-title .subtitle span{
	color: #ffa70d;
	font-weight: 400;
}
.homepage-ships .ship-nav{
	background: #f8f8f8;
	min-width: 240px;
	max-width: 1200px;
	margin: 0 auto 6px;
}
.homepage-ships .ship-nav .main-nav{
	margin: 0 auto;
	display: flex;
	justify-content: center;
	cursor: pointer;
}
.homepage-ships .ship-nav .main-nav li{
	width: 240px;
	height: 94px;
	text-align: center;
	position: relative;
}
.homepage-ships .ship-nav .main-nav li .ship-name{
	font-size: 22px;
	font-weight: bold;
	color: #152361;
	margin-top: 24px;
}
.homepage-ships .ship-nav .main-nav li img{
	width: 147px;
	margin: 0 auto;
}
.homepage-ships .ship-nav .main-nav li img.font2-img{
	display: none;
}
.homepage-ships .ship-nav .main-nav li .ship-new{
	width: 82px;
	height: 22px;
	content: url('https://resource.rcclchina.com.cn/homePage/homePage-new.png');
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: -12px;
}
.homepage-ships .ship-nav .main-nav li .ship-hot{
	width: 82px;
	height: 22px;
	content: url('https://resource.rcclchina.com.cn/homePage/homePage-hot.png');
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: -11px;
}
.homepage-ships .ship-nav .main-nav li.active{
	background: #0073bb;
}
.homepage-ships .ship-nav .main-nav li.active img.font1-img{
	display: none;
}
.homepage-ships .ship-nav .main-nav li.active img.font2-img{
	display: block;
}
.homepage-ships .ship-nav .main-nav li.active .ship-name{
	color: #fff;
}
.homepage-ships .main-experience {
	width: 1200px;
	margin: 0 auto;
}
.homepage-ships .main-experience .super-exper{
	display: none;
}
.homepage-ships .main-experience .super-exper.active{
	display: block;
}
.homepage-ships .main-experience .super-exper .exper-nav{
	margin-bottom: 6px;
	cursor:pointer;
}
.homepage-ships .main-experience .exper-list{
	width: 1200px;
	height: 483px;
	margin-bottom: 40px;
	cursor: pointer;
	overflow:hidden;
	display: flex;
}
.homepage-ships .main-experience .exper-list li{
	width: 146px;
	height: 100%;
	overflow: hidden;
	transition: all 0.5s;
	background: rgba(0, 8, 48, 0.4);
	position: relative;
	text-align: center;
	display: flex;
	justify-content: center;
}
.homepage-ships .main-experience .exper-list li .content{
	transition: all .5s ;
}
.homepage-ships .main-experience .exper-list li .detail{
	display:none;

}
.homepage-ships .main-experience .exper-list li.active .content{
	width: 100%;
	display: block;
}
.homepage-ships .main-experience .exper-list li.active{
	width: 480px;
}
.homepage-ships .main-experience .exper-list li.active .detail{
	display: block;
}
.homepage-ships .main-experience .exper-list li.active .exper-mask{
	opacity:0;
}

.homepage-ships .main-experience .exper-list li .exper-mask{
	position: absolute;
	left:0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0,8,48,.4);
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 20px;
	color: #fff;
	font-weight: bold;
}

/* .homepage-ships .main-experience .exper-list li img {

} */

.homepage-ships .main-experience .exper-list li .content{
	position: absolute;
	text-align: center;
	left: 0;
	top: 0;
	right: 0;
	padding-top: 28px;
	z-index: 999;
	width: 180px;
	display:none;
}
.homepage-ships .main-experience .exper-list li .content .detail{
	text-align: center;
}
.homepage-ships .main-experience .exper-list li .content .title{
	font-size: 20px;
	color: #fff;
	font-weight: bold;
	margin-bottom: 9px;
}
.homepage-ships .main-experience .exper-list li .content .border-line{
	width: 42px;
	height: 1px;
	background: #ffa70d;
	margin: 0 auto 7px;

}

.homepage-ships .main-experience .exper-list li .content .parah{
	font-size: 16px;
	color: #fff;
	line-height: 24px;
	width: 400px;
	margin: auto;
}
.homepage-ships .main-experience .exper-list li .content .a-btn{
	display: block;
	width: 110px;
	height: 26px;
	text-align: center;
	line-height: 26px;
	background: #fbc500;
	font-size: 14px;
	color: #333;
	margin: 11px auto 0;
}
.homepage-ships .main-experience .exper-list li .content .a-btn:hover{
	background: #f8de57;
}
/*精选目的地*/
.homepage-destinations{
	height: 1226px;
	/* //background: url(https://resource.rcclchina.com.cn/Home/new/dest/bg.jpg) no-repeat top center; */
  background: url(https://resource.rcclchina.com.cn/Home/new/dest/bg230817.jpg) no-repeat top center;
	/*background-size: 100% 100%;*/
}
.homepage-destinations .des-content{
	width: 1200px;
	margin: 0 auto;
	padding-top: 55px;
}
.homepage-destinations .des-content .main-title{
	margin-bottom: 30px;
	text-align: center;
}
.homepage-destinations .des-content .main-title .title{
	font-size: 30px;
	font-weight: bold;
	text-align: center;
	color: #282b2c;
}
.homepage-destinations .des-content .main-title .subtitle{
	font-size: 14px;
	text-align: center;
	color: #282b2c;
	font-weight: 500;
	line-height: 34px;
}
.homepage-destinations .img-area{
	position: relative;
	top: 19px;
}
.homepage-destinations .img-area div.wrap{
	position: absolute;
	cursor: pointer;
	overflow:hidden;
}
.homepage-destinations .img-area div.wrap:first-child:hover .mask,
.homepage-destinations .img-area div.wrap:nth-child(2):hover .mask,
.homepage-destinations .img-area div.wrap:nth-child(3):hover .mask,
.homepage-destinations .img-area div.wrap:nth-child(4):hover .mask,
.homepage-destinations .img-area div.wrap:nth-child(5):hover .mask,
.homepage-destinations .img-area div.wrap:nth-child(6):hover .mask,
.homepage-destinations .img-area div.wrap:nth-child(7):hover .mask,
.homepage-destinations .img-area div.wrap:nth-child(8):hover .mask
{
	top: 0px;
}

.homepage-destinations .img-area div.wrap:hover .bg-mask
{
	background: rgba(0, 67,141, 0.5);
}

.homepage-destinations .bg-mask{
	background: rgba(0,0,0,0);
	top: 0;
	transition: all .5s;
}
.homepage-destinations .mask,.homepage-destinations .bg-mask{
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
}
.homepage-destinations .mask{
	/*background: rgba(0,0,0,.4);*/
	transition: top .5s;
	z-index: 9;
}
.homepage-destinations .des-name{
	position: absolute;
	left: 30px;
	top: 14px;
	display: block;
	flex-direction: column;
	font-size: 32px;
	color: #fff;
	z-index: 999;
}
/*.homepage-destinations .img-area div.wrap:nth-child(6) .des-name{
	top: 14px;
}*/
.homepage-destinations .img-area div.wrap:nth-child(6) .mask .btn-area{
	bottom: 18px;
}
.homepage-destinations .des-name .cn{
   font-weight: bold;
   display: block;
   text-shadow: 1.286px 1.532px 13px rgba(37, 145, 191, 0.48);
}
.homepage-destinations .des-name .en{
	font-weight: 400;
	display: block;
	font-size: 22px;
	text-shadow: 1.286px 1.532px 13px rgba(37, 145, 191, 0.48);
}
.homepage-destinations .img-area div.wrap:last-child .des-name .en{
	font-size: 16px;
}

.homepage-destinations .img-area div.wrap:first-child{
	left:0;
	top: 80px;
}

.homepage-destinations .img-area div.wrap .mask{
	top: 362px;
	padding: 91px 38px 0 32px;
	box-sizing: border-box;
}
.homepage-destinations .img-area div.wrap:nth-child(6) .mask{
	padding-top: 90px;
}
div.wrap .mask .intro{
	color: #fff;
	font-size: 14px;
	line-height: 26px;
}
div.wrap .mask .btn-area{
	position: absolute;
	left: 34px;
	bottom: 30px;
}
div.wrap .mask .btn-area>span{
	margin-left: 18px;
	font-size: 14px;
	color: #fff;
}
div.wrap .mask .btn-area>img{
	margin-left: 2px;
	position: relative;
	top: -2px;
	margin-right: 2px;
}
div.wrap .mask .search-more{
	display: inline-block;
	width: 154px;
	height: 42px;
	line-height: 42px;
	text-align: center;
	font-size: 14px;
	background: #fbc500;
	color: #282b2c;

}

div.wrap .mask .search-more:hover {
	background: #f8de57;
}

.homepage-destinations .img-area div.wrap:nth-child(1) .mask{
	padding-top: 91px;
}

.homepage-destinations .img-area div.wrap:nth-child(2){
	/*top: 445px;
	left: 48px;*/
	left: 504px;
	top: 2px;
}
.homepage-destinations .img-area div.wrap:nth-child(2) .mask{
	top: 358px;
}
.homepage-destinations .img-area .video{
	width: 426px;
	height: 230px;
	top: 445px;
	left: 421px;
}

.homepage-destinations .img-area div.wrap:nth-child(3){
	left: 832px;
	top: 124px;
}
.homepage-destinations .img-area div.wrap:nth-child(3) .mask{
	top: 318px;
	padding-top: 91px;
}

.homepage-destinations .img-area div.wrap:nth-child(4){
	/*left: 505px;*/
	top: 445px;
	left: 49px;
}
.homepage-destinations .img-area div.wrap:nth-child(4) .mask{
	top: 442px;
}

.homepage-destinations .img-area .video .mask{
	top: 230px
}
.homepage-destinations .img-area .video .royal{
	position: absolute;
	left: 50%;
	top: 40%;
	transform: translateX(-50%);
}
.homepage-destinations .img-area .video .videoImg{
	position: absolute;
	left:50%;
	top: 50%;
	transform: translateX(-50%);
}

.homepage-destinations .img-area div.wrap:nth-child(6){
	top: 445px;
	left: 850px;
}
.homepage-destinations .img-area div.wrap:nth-child(6) .mask{
	top: 234px;
}
.homepage-destinations .img-area div.wrap:nth-child(7){
	left: 420px;
	top: 680px;
}
.homepage-destinations .img-area div.wrap:nth-child(7) .mask{
	top: 322px;
	padding-top: 95px;
}
.homepage-destinations .img-area div.wrap:nth-child(8){
	top: 680px;
	left: 776px;
}
.homepage-destinations .img-area div.wrap:nth-child(8) .mask{
	top: 376px;
}
/*精选游记*/
.homepage-reviews .rev-content{
	width: 1200px;
	margin: 0 auto;
	padding-top: 55px;
	padding-bottom: 40px;
}

.homepage-reviews .review-content {
	display: inline-block;
	width: 100%;
}

.homepage-reviews .review-image {
	width: 294px;
}

.homepage-reviews .rev-content .main-title {
	margin-bottom: 30px;
	text-align: center;
}
.homepage-reviews .rev-content .main-title .title {
	font-size: 30px;
	font-weight: bold;
	text-align: center;
	color: #282b2c;
}
.homepage-reviews .rev-content .main-title .subtitle {
	font-size: 14px;
	text-align: center;
	color: #282b2c;
	font-weight: 500;
	line-height: 34px;
}
.homepage-reviews .rev-content .rev-list{
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-bottom: 40px;
}
.homepage-reviews .rev-content .rev-list li{
	width: 294px;
	background: #fff;
	padding-bottom: 18px;
	cursor: pointer;
	display: inline-block;
	vertical-align: top;
	margin-bottom: 15px;
	overflow: hidden;
}
/*游记图片高度写死了*/
.homepage-reviews .rev-content .rev-list li img.rev-pic{
	height: 225px;
}

.homepage-reviews .score-image {
	width: 17px;
}


.homepage-reviews .rev-content .rev-list li:hover{
	box-shadow: 0px 0px 7px 3px rgba(46, 65, 80, 0.1);
}
.homepage-reviews .rev-content .rev-list li .rev-detail{
	padding: 20px 15px 0 15px;
	width: 100%;
}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-title{
	font-size:16px;
	color:#282b2c;
	margin-bottom:10px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;
	font-weight: 500;
}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-shiptime{
	font-size:14px;
	margin-bottom: 8px;
	color: #747d80;
	font-weight: 500;
}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-shipname{

	color: #747d80;
	font-weight: 500;
	font-size:14px;
	margin-bottom: 15px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-pernum{
	display: flex;
	justify-content: space-between;
}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-pernum .en-name{
	font-size: 16px;
	color: #282b2c;
	font-weight: 500;
}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-pernum .en-num{
	font-size: 14px;
	color: #747d80;
	margin-top: 8px;
}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-pernum .en-name img{
	position: relative;
	top: -2px;
	margin-right: 6px;

}
.homepage-reviews .rev-content .rev-list li .rev-detail .rev-pernum .en-num img{
	position: relative;
	top: -4px;
	margin-right: 2px;
}

.homepage-ships .ship-nav.is-full .main-nav {
  justify-content: center;
}
.homepage-ships .ship-nav.is-full .main-nav li{
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  gap: 10px;
  height: 100px;
}
.homepage-ships .ship-nav.is-full .main-nav li .ship-name{
  font-size: 22px;
  font-weight: bold;
  margin-top: 4px;
  line-height: 1;
}
.homepage-ships .ship-nav.is-full .main-nav li img {
  width: auto;
  height: 20px;
}
#layout-main-container {
	position: relative;
	min-width: 1280px !important;
	background-color: white;
}

.global-airline {
  display: block;
  margin: 15px auto 0;
  width: 1200px;
}
.global-airline img {
  display: block;
  width: 100%;
}
</style>
